import { Button } from "@mui/material"

export const DebugFormConsole = ({ values }) => {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (!inDebug) {
        return ""
    }

    return (
        <div>
            <Button
                variant='contained'
                color='primary'
                onClick={async () => console.log('valores form', values)}
            >
                Console Form Dev
            </Button>
        </div>
    )
}